import {
	wrapper,
	createApiClient,
	PaginationParams,
	Result,
	ApiError,
} from "../base";
import EnvironementDO = App.Data.EnvironmentDO;
import RoleDO = App.Data.RoleDO;
import UpdatePermissionDTO = App.Data.UpdatePermissionDTO;
import BulkUpdatePermissionDTO = App.Data.BulkUpdatePermissionDTO;
import { LaravelPaginatedCollection } from "@/types/collections";
import RoleListViewDTO = App.Data.RoleListViewDTO;
import DimensionDO = App.Data.DimensionDO;

const basePath = `roles`;
const baseClient = createApiClient();

type RoleParams = PaginationParams & {
	sort?: string;
	"filter[name]"?: string;
};

export default class {
	getRoles(
		params: RoleParams = {}
	): Promise<Result<LaravelPaginatedCollection<RoleDO>, ApiError>> {
		params["type"] = "full";
		return wrapper(baseClient.get(`${basePath}`, { params }));
	}

	getRoleListViews(
		params: RoleParams = {}
	): Promise<Result<LaravelPaginatedCollection<RoleListViewDTO>, ApiError>> {
		return wrapper(baseClient.get(`${basePath}`, { params }));
	}
	getNewRole(): Promise<Result<RoleDO, ApiError>> {
		return wrapper(baseClient.get(`${basePath}/new`));
	}
	createRole(role: RoleDO): Promise<Result<RoleDO, ApiError>> {
		return wrapper(baseClient.post(`${basePath}`, role));
	}
	removeRole(uuid: string): Promise<Result<string, ApiError>> {
		return wrapper(baseClient.delete(`${basePath}/${uuid}`));
	}
	updateRole(role: RoleDO): Promise<Result<EnvironementDO, ApiError>> {
		return wrapper(baseClient.put(`${basePath}/${role.uuid}`, role));
	}
	getRoleByUUID(uuid: string | string[]): Promise<Result<RoleDO, ApiError>> {
		return wrapper(baseClient.get(`${basePath}/${uuid}`));
	}
	updatePermission(
		updatePermissionDTO: UpdatePermissionDTO,
		uuid: string | string[]
	): Promise<Result<string, ApiError>> {
		return wrapper(
			baseClient.put(
				`${basePath}/${uuid}/updatePermission/${updatePermissionDTO.name}`,
				updatePermissionDTO
			)
		);
	}

	bulkUpdatePermission(
		dto: BulkUpdatePermissionDTO,
		uuid: string | string[]
	): Promise<Result<string, ApiError>> {
		return wrapper(
			baseClient.put(`${basePath}/${uuid}/bulkUpdatePermission`, dto)
		);
	}

	getRoleFavoriteDimensions(
		uuid: string | string[]
	): Promise<Result<DimensionDO[], ApiError>> {
		return wrapper(baseClient.get(`${basePath}/${uuid}/favorite-dimensions`));
	}

	addRoleFavoriteDimension(
		uuid: string | string[],
		dimension: DimensionDO
	): Promise<Result<string, ApiError>> {
		return wrapper(
			baseClient.post(
				`${basePath}/${uuid}/favorite-dimensions/${dimension.name_clean}`
			)
		);
	}

	removeRoleFavoriteDimension(
		uuid: string | string[],
		dimension: DimensionDO
	): Promise<Result<string, ApiError>> {
		return wrapper(
			baseClient.delete(
				`${basePath}/${uuid}/favorite-dimensions/${dimension.name_clean}`
			)
		);
	}
}
